/* ============================================================
   SILKEE SOFT — mobile UX behaviour
   Powers the tappable components that replaced paragraphs:
     1. ritual stepper      [data-mux-stepper]
     2. ingredient sheet    [data-mux-sheet-open]
     3. tracker add chips   [data-mux-add]
     4. free-delivery bar   [data-mux-bar]
     5. kit / singles toggle[data-mux-toggle]
     6. payment cards       [data-mux-pay]
   Cart work is delegated to window.SilkeeCart (exposed by theme.js)
   so the drawer, the count bubble and the toast all stay in sync.
   Every component degrades to readable static markup without JS.
   ============================================================ */
(function () {
  "use strict";
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  function money(paise) {
    return "Rs. " + Math.round(paise / 100).toLocaleString("en-PK");
  }
  function SC() { return window.SilkeeCart || null; }

  /* ---------- cart state, shared by every component ---------- */
  var cart = null;
  var listeners = [];
  function onCart(fn) { listeners.push(fn); if (cart) fn(cart); }
  /* Announcing the new cart is what keeps the ritual tracker in step. It used to
     re-read /cart.js on a fixed timer after a tap, which raced the add and left
     the counter one behind on fast taps. */
  function publish(c) {
    cart = c;
    listeners.forEach(function (fn) { try { fn(c); } catch (e) {} });
    document.dispatchEvent(new CustomEvent("silkee:cart", { detail: c }));
  }

  function loadCart() {
    var api = SC();
    if (api) return api.get().then(publish);
    return fetch("/cart.js", { headers: { Accept: "application/json" } })
      .then(function (r) { return r.json(); }).then(publish);
  }

  /* Adds are QUEUED, never fired in parallel. Shopify's cart endpoints reject
     concurrent writes to the same cart, so three quick taps on the step chips
     used to land as one line and silently drop the other two. Chaining them
     costs a few hundred milliseconds and makes every tap count. */
  var queue = Promise.resolve();
  function addVariant(id, qty, meta) {
    var run = function () {
      var api = SC();
      if (api) return api.add(id, qty, meta).then(function (c) { api.render(c); publish(c); return c; });
      return fetch("/cart/add.js", {
        method: "POST", headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: id, quantity: qty })
      }).then(loadCart);
    };
    queue = queue.then(run, run);
    return queue;
  }

  function say(msg) {
    var api = SC();
    if (api && api.toast) api.toast(msg);
  }

  function idsInCart(c) {
    var set = {};
    (c && c.items ? c.items : []).forEach(function (i) { set[String(i.variant_id || i.id)] = i.quantity; });
    return set;
  }

  /* ============================================================
     1. Ritual stepper — one card at a time instead of six stacked
     ============================================================ */
  $$("[data-mux-stepper]").forEach(function (root) {
    var chips = $$("[data-mux-step]", root);
    var cards = $$("[data-mux-stepcard]", root);
    var dots = $$("[data-mux-dot]", root);
    /* every card carries its own prev/next pair, so wire them all */
    var prevs = $$("[data-mux-prev]", root);
    var nexts = $$("[data-mux-next]", root);
    if (!chips.length || !cards.length) return;
    var at = 0;

    function show(i) {
      at = Math.max(0, Math.min(cards.length - 1, i));
      chips.forEach(function (c, n) { c.setAttribute("aria-selected", n === at ? "true" : "false"); });
      cards.forEach(function (c, n) { c.hidden = n !== at; });
      dots.forEach(function (d, n) { d.classList.toggle("on", n === at); });
      prevs.forEach(function (b) { b.disabled = at === 0; });
      nexts.forEach(function (b) { b.disabled = at === cards.length - 1; });
      var chip = chips[at];
      if (chip && chip.scrollIntoView) chip.scrollIntoView({ block: "nearest", inline: "center", behavior: "smooth" });
    }
    chips.forEach(function (c, n) { c.addEventListener("click", function () { show(n); }); });
    prevs.forEach(function (b) { b.addEventListener("click", function () { show(at - 1); }); });
    nexts.forEach(function (b) { b.addEventListener("click", function () { show(at + 1); }); });
    show(0);
  });

  /* ============================================================
     2. Ingredient bottom sheet — pills open the full INCI
     ============================================================ */
  var sheet = $("[data-mux-sheet]");
  if (sheet) {
    var sTitle = $("[data-mux-sheet-title]", sheet);
    var sSub = $("[data-mux-sheet-sub]", sheet);
    var sBody = $("[data-mux-sheet-body]", sheet);
    var sClaims = $("[data-mux-sheet-claims]", sheet);
    var lastFocus = null;

    function openSheet(d) {
      lastFocus = document.activeElement;
      if (sTitle) sTitle.textContent = d.title || "";
      if (sSub) sSub.textContent = d.sub || "";
      if (sBody) sBody.textContent = d.body || "";
      if (sClaims) {
        sClaims.innerHTML = "";
        (d.claims || "").split("·").forEach(function (c) {
          c = c.trim(); if (!c) return;
          var el = document.createElement("span"); el.textContent = c; sClaims.appendChild(el);
        });
      }
      sheet.classList.add("open");
      document.body.style.overflow = "hidden";
      var close = $("[data-mux-sheet-close]", sheet);
      if (close) close.focus();
    }
    function closeSheet() {
      sheet.classList.remove("open");
      document.body.style.overflow = "";
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }
    $$("[data-mux-sheet-close], [data-mux-sheet-scrim]", sheet).forEach(function (b) {
      b.addEventListener("click", closeSheet);
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && sheet.classList.contains("open")) closeSheet();
    });
    $$("[data-mux-sheet-open]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        openSheet({
          title: btn.getAttribute("data-title"),
          sub: btn.getAttribute("data-sub"),
          body: btn.getAttribute("data-inci"),
          claims: btn.getAttribute("data-claims")
        });
      });
    });
  }

  /* ============================================================
     3. Tracker chips that actually add to cart
     ============================================================ */
  var adds = $$("[data-mux-add]");
  if (adds.length) {
    adds.forEach(function (btn) {
      btn.addEventListener("click", function () {
        if (btn.classList.contains("is-in") || btn.classList.contains("is-busy")) return;
        var id = btn.getAttribute("data-mux-add");
        if (!id) return;
        btn.classList.add("is-busy");
        addVariant(id, 1, {
          title: btn.getAttribute("data-title"),
          product_title: btn.getAttribute("data-title"),
          price: parseInt(btn.getAttribute("data-price"), 10),
          image: btn.getAttribute("data-image")
        }).then(function () {
          say("Added — " + btn.getAttribute("data-title"));
        })["catch"](function () {
          btn.classList.remove("is-busy");
          say("Couldn't add that. Please try again.");
        });
      });
    });
    onCart(function (c) {
      var inCart = idsInCart(c);
      adds.forEach(function (btn) {
        var on = !!inCart[btn.getAttribute("data-mux-add")];
        btn.classList.remove("is-busy");
        btn.classList.toggle("is-in", on);
        var tick = $(".mux-add__tick", btn);
        if (tick) tick.textContent = on ? "✓" : "+";
        btn.setAttribute("aria-label", (on ? "In your bag: " : "Add to bag: ") + (btn.getAttribute("data-title") || ""));
      });
    });
  }

  /* ============================================================
     4. Free-delivery progress bar — real Rs. 1,500 threshold
     ============================================================ */
  $$("[data-mux-bar]").forEach(function (bar) {
    var threshold = parseInt(bar.getAttribute("data-threshold"), 10) || 150000;
    var fill = $("[data-mux-bar-fill]", bar);
    var label = $("[data-mux-bar-label]", bar);
    var amount = $("[data-mux-bar-amount]", bar);
    onCart(function (c) {
      var total = (c && c.total_price) || 0;
      var pct = Math.min(100, Math.round((total / threshold) * 100));
      var left = threshold - total;
      if (fill) fill.style.width = pct + "%";
      bar.classList.toggle("mux-bar--done", left <= 0);
      if (label) {
        label.innerHTML = left <= 0
          ? "Delivery is <b>free</b> on this order"
          : "<b>" + money(left) + "</b> away from free delivery";
      }
      if (amount) amount.textContent = pct + "%";
    });
  });

  /* ============================================================
     5. Kit vs singles — recalculates in place, no table
     ============================================================ */
  $$("[data-mux-toggle]").forEach(function (root) {
    var btns = $$("[data-mux-mode]", root);
    var views = $$("[data-mux-view]", root);
    function set(mode) {
      btns.forEach(function (b) { b.setAttribute("aria-pressed", b.getAttribute("data-mux-mode") === mode ? "true" : "false"); });
      views.forEach(function (v) { v.hidden = v.getAttribute("data-mux-view") !== mode; });
    }
    btns.forEach(function (b) { b.addEventListener("click", function () { set(b.getAttribute("data-mux-mode")); }); });
    set(root.getAttribute("data-mux-toggle") || "kit");
  });

  /* ============================================================
     6. Payment preference cards
     ============================================================ */
  $$("[data-mux-pay]").forEach(function (root) {
    var cards = $$("[data-mux-pay-card]", root);
    var notes = $$("[data-mux-pay-note]", root);
    cards.forEach(function (card) {
      card.addEventListener("click", function () {
        var key = card.getAttribute("data-mux-pay-card");
        cards.forEach(function (c) { c.setAttribute("aria-pressed", c === card ? "true" : "false"); });
        notes.forEach(function (n) { n.hidden = n.getAttribute("data-mux-pay-note") !== key; });
      });
    });
  });

  /* ---------- kick off ---------- */
  if (adds.length || $$("[data-mux-bar]").length) {
    loadCart()["catch"](function () {});
  }
})();
